import React from 'react';

const Loader = () => {
	return (
		<div className="loader">
			<div className="bouncer">
				<div>
					<img src="https://i.ya-webdesign.com/images/8-bit-pc-png-2.png" alt="pokeball" />
				</div>
				<div>
					<img src="https://i.ya-webdesign.com/images/8-bit-pc-png-2.png" alt="pokeball" />
				</div>
				<div>
					<img src="https://i.ya-webdesign.com/images/8-bit-pc-png-2.png" alt="pokeball" />
				</div>
				<div>
					<img src="https://i.ya-webdesign.com/images/8-bit-pc-png-2.png" alt="pokeball" />
				</div>
			</div>
			<p className="loader-title">Catchin' em All!</p>
		</div>
	);
};

export default Loader;
